(function() {
    'use strict';

    angular.module('order')
        .controller('OrderSenderAddressModalController', OrderSenderAddressModalController);

    OrderSenderAddressModalController.$inject = ['lodashService', 'orderDataSrvc', 'notificationSrvc', 'errorNotificationSrvc', '$uibModalInstance', 'order'];

    function OrderSenderAddressModalController(lodashService, orderDataSrvc, notificationSrvc, errorNotificationSrvc, $uibModalInstance, order) {
        var self = this;

        self.order = order;
        self.serverErrors = {};
        self.ok = ok;
        self.updateSenderAddress = updateSenderAddress;
        self.cleanErrors = cleanErrors;

        activate();

        function activate() {
            if (self.order.sender_address === null) {
                self.order.sender_address = {}
            }
        }

        function ok() {
            self.order = null;
            $uibModalInstance.dismiss('cancel');
        }

        function updateSenderAddress() {
            orderDataSrvc.senderAddressUpdate({
                pk: self.order.pk
            }, {
                sender_address: self.order.sender_address
            }).$promise.then(
                function (response) {
                    $uibModalInstance.close();
                },
                function (response) {
                    errorNotificationSrvc.displayErrors(response.data);
                    self.serverErrors = response.data;
                }
            )
        }

        function cleanErrors(errorField, key) {
            errorField[key] = [];
        }
    }
})();
